import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import TEPCard from "../tepl-cards/common/TEPCard";
import { selectAuth } from "../../auth/auth.selector";
import { BodyBuilder, TotalPTMembers } from "../../../exports/Images";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import { fetchApiData } from "../../../redux/reducers/commonApiSlice";
import { fetchGTPTtrainersStats } from "../../../redux/reducers/apiSlice";
import { gtptTrainersGet } from "../../../data/ApiEndpoints";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";
import { convertStraight, convertThenFormat } from "../../common-data/Converts";
import moment from "moment";
import OccupencyDetails from "../../components-react/OccupencyDetails";
import PtDetails from "../trainer-details/common/PtDetails";
import { parseQueryStringToObject, isManagerRole as checkIsManagerRole } from "../../common-data/Conversions";

const GTPTtrainers = ({ queryParametersForAll }) => {
  const dispatch = useDispatch();

  const authData = useSelector(selectAuth);
  const userInfoData = authData.user;

  const isAdmin = userInfoData?.account_type === "admin";
  const isManagerRole = checkIsManagerRole(userInfoData);

  const {
    // loading: apiLoading,
    gtptTrainerStats,
  } = useSelector((state) => state.api);
  const { loading: commonLoading, data } = useSelector((state) => state.common);

  const sendableStatsQPsObject = parseQueryStringToObject(
    queryParametersForAll
  );

  const [isPage, setIsPage] = useState(0);
  const initialFilters = {
    selectedGym: !isAdmin && !isManagerRole
      ? {
          label: userInfoData?.gym_name || "",
          value: userInfoData?.gym_id || "",
        }
      : "",
  };
  const [allFilters, setAllFilters] = useState(initialFilters);
  const iniFilters = {
    limit: 10,
    page: isPage + 1,
    gym_id: allFilters.selectedGym?.value || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const iniTbDatas = {
    allTrainersStats: {},
    trainerData: [],
    pagination: [],
  };
  const [tbDatas, setTbDatas] = useState(iniTbDatas);
  const iniModValues = {
    isModOpen: false,
    cardType: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModValues);
  const iniClickVals = {
    shiftDetailModal: false,
    trainerId: "",
    gymId: "",
    cardName: "",

    viewImage: "",
    userName: "",
    userNo: "",
  };
  const [clickValues, setClickValues] = useState(iniClickVals);
  const [shiftFormattedQP, setShiftFormattedQP] = useState("");
  const iniTbFilters = {
    gym_id: clickValues.gymId || "",
    trainer_id: clickValues.trainerId || "",
  };
  const [tbFilters, setTbFilters] = useState(iniTbFilters);

  const onClickCard = (filterType) => {
    setModValues((prevs) => ({
      ...prevs,
      cardType: filterType,
      isModOpen: true,
    }));
  };

  const closeModal = () => {
    setModValues(iniModValues);
    setTbDatas((prevs) => ({
      ...prevs,
      trainerData: [],
      pagination: [],
    }));
  };

  const onCloseModal = () => {
    setClickValues(iniClickVals);
  };

  const onClickValues = (e, row, name) => {
    e.preventDefault();

    if (name === "view-img") {
      setClickValues({
        imageModal: true,
        viewImage: row?.trainer_profile || BodyBuilder,
        userName: row?.trainer_name || "",
        userNo: row?.trainer_mobile || "",
        cardName: name,
      });
    } else {
      setClickValues((prevs) => ({
        ...prevs,
        shiftDetailModal: true,
        trainerId: row?.trainer_id || "",
        gymId: row?.gym_id || "",
        cardName: name,
      }));
    }
  };

  function getTrainersStats() {
    const updatedFilters = {
      type: "trainer_pt_status",
      gym_id: sendableStatsQPsObject?.gym_id || "",
    };

    dispatch(
      fetchGTPTtrainersStats({
        filters: updatedFilters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    setAllFilters((prevs) => ({
      ...prevs,
      selectedGym: !isAdmin
        ? {
            label: userInfoData?.gym_name || "",
            value: userInfoData?.gym_id || "",
          }
        : "",
    }));
  }, [userInfoData?.gym_id]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      gym_id: sendableStatsQPsObject?.gym_id || "",
    }));
  }, [isPage, sendableStatsQPsObject?.gym_id]);

  useEffect(() => {
    getTrainersStats();
  }, [sendableStatsQPsObject?.gym_id]);

  useEffect(() => {
    if (modValues.cardType) {
      const updatedFilters = {
        ...filters,
        trainer_type: modValues.cardType,
      };

      dispatch(
        fetchApiData({
          method: "GET",
          endpoint: gtptTrainersGet,
          payload: {
            filters: updatedFilters,
          },
          token: userInfoData?.token,
        })
      );
    }
  }, [modValues.cardType, isPage]);

  useEffect(() => {
    if (gtptTrainerStats?.status && gtptTrainerStats?.data) {
      setTbDatas((prevs) => ({
        ...prevs,
        allTrainersStats: gtptTrainerStats.data,
      }));
    } else {
      setTbDatas((prevs) => ({
        ...prevs,
        allTrainersStats: {},
      }));
    }
  }, [gtptTrainerStats]);

  useEffect(() => {
    if (data?.status && data?.data) {
      setTbDatas((prevs) => ({
        ...prevs,
        trainerData: data.data,
        pagination: data?.pagination || [],
      }));
    } else {
      setTbDatas((prevs) => ({
        ...prevs,
        trainerData: [],
        pagination: [],
      }));
    }
  }, [data]);

  useEffect(() => {
    const trainerQP = `&trainer_id=${clickValues.trainerId || ""}`;
    const gymQP = `&gym_id=${clickValues.gymId || ""}`;
    const allQP = `${trainerQP}${gymQP}`;
    setShiftFormattedQP(allQP);

    setTbFilters((prevs) => ({
      ...prevs,
      gym_id: clickValues.gymId || "",
      trainer_id: clickValues.trainerId || "",
    }));
  }, [clickValues.trainerId, clickValues.gymId]);

  const tbColumns = [
    {
      dataField: "gym_name",
      text: "gym name",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth150">{row?.gym_name || "NA"}</span>
        );
      },
    },
    {
      dataField: "trainer_name",
      text: "Trainer/PT",
      formatter: (cell, row, rowIndex) => (
        <div
          className="emeberDetailsRowContainer"
          style={{ textAlign: "center" }}
        >
          <img
            src={row?.trainer_profile || BodyBuilder}
            alt={row?.trainer_name || "N/A"}
            className="image"
            style={{
              width: "60px",
              height: "60px",
              borderRadius: "4px",
              border: "1px solid #000",
              padding: "10px",
              cursor: "pointer",
            }}
            onClick={(e) => {
              onClickValues(e, row, "view-img");
            }}
          />
          <span
            className="tb-data hoverBlue minWidth150"
            style={{
              textAlign: "start",
              textDecoration: "underline",
            }}
            onClick={(e) => onClickValues(e, row, "shift-details")}
          >
            {row?.trainer_name || "NA"}
            {row?.trainer_category === "Personal Trainer" ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-patch-check-fill"
                viewBox="0 0 16 16"
                style={{
                  marginLeft: "5px",
                  color: "#379C00",
                }}
              >
                <path d="M10.067.87a2.89 2.89 0 0 0-4.134 0l-.622.638-.89-.011a2.89 2.89 0 0 0-2.924 2.924l.01.89-.636.622a2.89 2.89 0 0 0 0 4.134l.637.622-.011.89a2.89 2.89 0 0 0 2.924 2.924l.89-.01.622.636a2.89 2.89 0 0 0 4.134 0l.622-.637.89.011a2.89 2.89 0 0 0 2.924-2.924l-.01-.89.636-.622a2.89 2.89 0 0 0 0-4.134l-.637-.622.011-.89a2.89 2.89 0 0 0-2.924-2.924l-.89.01zm.287 5.984-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7 8.793l2.646-2.647a.5.5 0 0 1 .708.708" />
              </svg>
            ) : null}
            <br />
            <small style={{ textTransform: "lowercase" }}>
              {row?.trainer_mobile || ""}
              <br />
              {row?.trainer_email || ""}
            </small>
          </span>
        </div>
      ),
    },
    {
      dataField: "joining_date",
      text: "Trainer Joining Date",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.joining_date ? convertStraight(row.joining_date) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "salary",
      text: "Trainer Salary",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            ₹{convertThenFormat(row?.salary || 0)}
          </span>
        );
      },
    },
    {
      dataField: "shift_timing",
      text: "Trainer Shift",
      formatter: (cell, row) => {
        const shiftTimings = row?.shift_timing?.map((shift) => {
          const startTime = shift?.start_time
            ? moment(shift.start_time, "HH:mm")
                .tz("Asia/Kolkata")
                .format("h:mmA")
            : "";
          const endTime = shift?.end_time
            ? moment(shift.end_time, "HH:mm").tz("Asia/Kolkata").format("h:mmA")
            : "";
          return `${startTime}-${endTime}`;
        });

        const shiftTiming = shiftTimings
          ? shiftTimings?.join(", ")
          : "No Shift Found";

        return <span className="tb-data minWidth150">{shiftTiming || ""}</span>;
      },
    },
    {
      dataField: "pt_this_month_added_amount",
      text: "PT This Month Amount/(Partial/Full)",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth150">
            <b>₹{convertThenFormat(row?.pt_this_month_added_amount || 0)}</b>
            <br />
            (₹{convertThenFormat(
              row?.pt_this_month_added_amount_partial || 0
            )}{" "}
            / {convertThenFormat(row?.pt_this_month_added_amount_full || 0)})
          </span>
        );
      },
    },
    {
      dataField: "total_active_pt",
      text: "Active PT",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data minWidth100 withPadding borderRdius8  bold"
            style={{
              background: "#E2EFD5",
              color: "#379C00",
              textDecoration: "underline",
              cursor: "pointer",
            }}
            onClick={(e) => onClickValues(e, row, "active")}
          >
            {row?.total_active_pt || 0} / {row?.total_pt || 0}
          </span>
        );
      },
    },
    {
      dataField: "pt_this_month_added",
      text: "PT Added This Month",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data minWidth100 withPadding borderRdius8  bold"
            style={{
              background: "#E2EFD5",
              color: "#379C00",
              textDecoration: "underline",
              cursor: "pointer",
            }}
            onClick={(e) => onClickValues(e, row, "pt-this-month")}
          >
            {row?.pt_this_month_added || 0}
            {/* <br />
            <small style={{ textDecoration: "none" }}>
              {row?.pt_this_month_added_amount
                ? `(₹${convertThenFormat(row.pt_this_month_added_amount || 0)})`
                : null}
            </small> */}
          </span>
        );
      },
    },
    {
      dataField: "total_expiring_pt",
      text: "Expiring PT",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data minWidth100 withPadding borderRdius8  bold"
            style={{
              background: "#F6EFEF",
              color: "#F13434",
              textDecoration: "underline",
              cursor: "pointer",
            }}
            onClick={(e) => onClickValues(e, row, "expiring")}
          >
            {row?.total_expiring_pt || 0}
          </span>
        );
      },
    },
    {
      dataField: "total_expired_pt",
      text: "Expired PT",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data minWidth100 withPadding borderRdius8  bold"
            style={{
              background: "#F6EFEF",
              color: "#F13434",
              textDecoration: "underline",
              cursor: "pointer",
            }}
            onClick={(e) => onClickValues(e, row, "expired")}
          >
            {row?.total_expired_pt || 0}
          </span>
        );
      },
    },
  ];

  return (
    <>
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={closeModal}
        contentLabel="Add Modal"
        ariaHideApp={false}
      >
        <div className="createNewCTOModalContainer">
          <ModalHeadAndClose
            title={`${modValues.cardType?.replace(/_/g, " ")}`}
            onClose={closeModal}
          />

          <div className="fullWidthFlexCenter overflowAuto separatedTable">
            {commonLoading ? (
              <ReactVortoxSpinner />
            ) : (
              <PaymentLinkTable
                tableData={tbDatas.trainerData}
                tableColumns={tbColumns}
                tablePagination={tbDatas.pagination}
                isPage={isPage}
                setIsPage={setIsPage}
              />
            )}
          </div>
        </div>
      </Modal>

      <Modal
        isOpen={clickValues.shiftDetailModal}
        onRequestClose={onCloseModal}
        contentLabel="Trainer Shift Details Modal"
        ariaHideApp={false}
      >
        <div className="createNewCTOModalContainer">
          <ModalHeadAndClose
            title={`${clickValues.cardName?.replace(/-/g, " ")}`}
            onClose={onCloseModal}
          />

          {clickValues.cardName === "active" ||
          clickValues.cardName === "expiring" ||
          clickValues.cardName === "expired" ||
          clickValues.cardName === "pt-this-month" ? (
            <PtDetails allInfo={clickValues} filters={tbFilters} />
          ) : clickValues.cardName === "shift-details" ? (
            <OccupencyDetails queryParametersForAll={shiftFormattedQP} />
          ) : clickValues.cardName === "view-img" ? (
            <div className="discussionModalMessage mt30">
              <img
                src={clickValues.viewImage}
                alt="profile"
                style={{
                  width: "400px",
                  height: "400px",
                  objectFit: "contain",
                }}
              />
            </div>
          ) : null}

          {/* <OccupencyDetails queryParametersForAll={shiftFormattedQP} /> */}
        </div>
      </Modal>

      <div
        className="cards-container cards-grid-container threeGridSystem ptFlow"
        // style={{
        //   gridTemplateColumns: "repeat(3, 1fr)",
        // }}
      >
        <TEPCard
          filterType={"total_pt_trainer"}
          cardImg={TotalPTMembers}
          total={tbDatas.allTrainersStats?.total_pt_trainer || 0}
          cardTitle={"Total PT Trainers"}
          onClickCard={onClickCard}
          isTrainerValue={true}
        />

        <TEPCard
          filterType={"pt_trainer_with_pt"}
          cardImg={TotalPTMembers}
          total={tbDatas.allTrainersStats?.pt_trainer_with_pt || 0}
          cardTitle={"Trainers With PT"}
          onClickCard={onClickCard}
          isTrainerValue={true}
        />

        <TEPCard
          filterType={"pt_trainer_without_pt"}
          cardImg={TotalPTMembers}
          total={tbDatas.allTrainersStats?.pt_trainer_without_pt || 0}
          cardTitle={"Trainers Without PT"}
          onClickCard={onClickCard}
          isTrainerValue={true}
        />
      </div>
    </>
  );
};

export default GTPTtrainers;
